/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  settings.ts
 */

import { getLiveEnv } from '@zcode/settings'

import {
  getLogLevelFromName,
  isLogLevelName,
} from './helpers/getLogLevelFromName'

import { LOG_LEVEL_DEBUG, LOG_LEVEL_ERROR } from './constants'

export const ENV_LOG_LEVEL_NAME = getLiveEnv('LOG_LEVEL')

/* istanbul ignore next */
export const ENV_LOG_LEVEL = isLogLevelName(ENV_LOG_LEVEL_NAME)
  ? getLogLevelFromName(ENV_LOG_LEVEL_NAME)
  : undefined

/* istanbul ignore next */
export const DEFAULT_LOG_LEVEL =
  process.env.NODE_ENV === 'production'
    ? ENV_LOG_LEVEL ?? LOG_LEVEL_ERROR
    : LOG_LEVEL_DEBUG
